import tinymce from 'tinymce';
import 'tinymce/themes/silver';
import 'tinymce/icons/default';
import 'tinymce/skins/ui/oxide/content.min.css';
import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/importcss';
import 'tinymce/plugins/code';
import 'tinymce/plugins/image';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/autosave';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/codesample';
import 'tinymce/plugins/directionality';
import 'tinymce/plugins/help';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/media';
import 'tinymce/plugins/nonbreaking';
import 'tinymce/plugins/pagebreak';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/save';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/table';
import 'tinymce/plugins/template';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/visualchars';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/models/dom';

// This is a polyfill to tell tinymce to load CSS from a different directory to the JS
const defaults = {
    theme:'silver',
    resize: true,
    skin_url: '/static/dist/tinymce/js/skins/ui/oxide',
    deprecation_warnings: false,
    skin: false,
    height: 200,
    content_style: "body {font-family: verdana;} #tinymce.mce-content-readonly { cursor: not-allowed; background-color: #eee; }",
    promotion: false,
    convert_unsafe_embeds: true,
}
const baseInit = tinymce.init;
tinymce.init = (args) => baseInit.apply(tinymce, [{ ...defaults, ...args }]);

export default tinymce;
